import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/zh-cn/checklists/$slug")({
  head: () => buildRouteHead("/zh-cn/checklists", { noIndex: true }),
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/zh-cn/downloads/checklists/$slug",
      params: { slug: params.slug },
      replace: true,
    });
  },
});
